<template>
    <div>
        <div ref="slider" class="owl-carousel owl-theme">
            <slot name="sliders" v-bind="{ goToSlide }" ></slot>
        </div>
    </div>

</template>

<script>
    import 'owl.carousel';
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            startPosition: {
                type: [String, Number],
                default: 0
            },
            loop: {
                type: Boolean,
                default: false
            },
            animateOut: {
                type: [ String, Boolean],
                default: false
            },
            nav: {
                type: Boolean,
                default: false
            },
            dots: {
                type: Boolean,
                default: false
            },
            mouseDrag: {
                type: Boolean,
                default: false
            },
            touchDrag: {
                type: Boolean,
                default: false
            },
            items: {
                type: [String, Boolean],
                default: 1
            }
        },
        data() {
            return {
                slider: null
            };
        },
        mounted() {
            this.slider = $(this.$refs.slider).owlCarousel({
                startPosition: this.startPosition,
                items: +this.items,
                loop: this.loop,
                animateOut: this.animateOut,
                mouseDrag: this.mouseDrag,
                touchDrag: this.touchDrag,
                dots: this.dots,
                rewind: true,
                nav: this.nav
            });
        },
        methods: {
            goToSlide(nSlide){
                this.slider.trigger('to.owl.carousel', nSlide)
            }
        }
    }
</script>
